<nav
  [ngClass]="
    isMobileNav
      ? 'fixed bottom-0 left-0 right-0 w-full bg-white text-gray-900 dark:bg-gray-800 dark:text-white shadow-lg'
      : ' bg-white text-gray-900 dark:bg-gray-800 dark:text-white'
  "
>
  <ul [ngClass]="isMobileNav ? 'flex justify-around' : ''">
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a
        routerLink="/app/dashboard"
        routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        data-cy="page-nav-link-dashboard"
        [ngClass]="
          isMobileNav
            ? 'flex flex-col items-center text-xs px-2 py-2'
            : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'
        "
      >
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">dashboard</span>
        Dashboard
      </a>
    </li>
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a
        routerLink="/app/calendar"
        routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        data-cy="page-nav-link-calendar"
        [ngClass]="
          isMobileNav
            ? 'flex flex-col items-center text-xs px-2 py-2'
            : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'
        "
      >
        <span
          class="material-symbols-outlined"
          [ngClass]="isMobileNav ? '' : 'mr-2'"
          data-cy="page-allAppointments-icon-calendarWidget"
          >calendar_month</span
        >
        Calendar
      </a>
    </li>
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a
        aria-disabled="true"
        data-cy="page-nav-link-tasks"
        class="flex items-center p-2 rounded-md text-gray-400 dark:text-gray-500 cursor-not-allowed"
        [ngClass]="isMobileNav ? 'flex flex-col items-center text-xs px-2 py-2' : 'flex items-center p-2 rounded-md'"
      >
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">checklist</span>
        Tasks
      </a>
    </li>
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a
        routerLink="/app/cases"
        routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        data-cy="page-nav-link-cases"
        [ngClass]="
          isMobileNav
            ? 'flex flex-col items-center text-xs px-2 py-2'
            : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'
        "
      >
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">cases</span>
        Cases
      </a>
    </li>
    @if (!isMobileNav) {
      <li [ngClass]="isMobileNav ? '' : 'mb-2'">
        <a
          routerLink="/app/library"
          routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
          data-cy="page-nav-link-library"
          [ngClass]="
            isMobileNav
              ? 'flex flex-col items-center text-xs px-2 py-2'
              : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'
          "
        >
          <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">school</span>
          Library
        </a>
      </li>
      <li [ngClass]="isMobileNav ? '' : 'mb-2'">
        <a
          routerLink="/app/profile"
          routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
          data-cy="page-nav-link-account"
          [ngClass]="
            isMobileNav
              ? 'flex flex-col items-center text-xs px-2 py-2'
              : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'
          "
        >
          <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">person</span>
          Account
        </a>
      </li>
    }
    @if (isMobileNav) {
      <li class="relative">
        <button
          #moreTrigger="cdkOverlayOrigin"
          cdkOverlayOrigin
          (click)="toggleMoreMenu()"
          aria-haspopup="true"
          data-cy="page-nav-button-more"
          [attr.aria-expanded]="isMoreMenuOpen()"
          class="flex flex-col items-center text-xs px-2 py-2"
        >
          <span class="material-symbols-outlined">more_horiz</span>
          More
        </button>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="moreTrigger"
          [cdkConnectedOverlayOpen]="isMoreMenuOpen()"
          [cdkConnectedOverlayPositions]="overlayPositions"
          [cdkConnectedOverlayHasBackdrop]="true"
          backdropClass="cdk-overlay-transparent-backdrop"
          (backdropClick)="closeMoreMenu()"
          (detach)="closeMoreMenu()"
        >
          <div
            class="w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg border dark:border-gray-700 z-50"
            (keydown.escape)="closeMoreMenu()"
            tabindex="0"
          >
            <!-- Library -->
            <a
              routerLink="/app/library"
              routerLinkActive="!bg-sky-200 !text-black dark:!bg-gray-700 dark:!text-white"
              (click)="closeMoreMenu()"
              data-cy="page-nav-link-library-mobile"
              class="flex items-center p-2 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-150"
            >
              <span class="material-symbols-outlined mr-2">school</span>
              Library
            </a>

            <!-- Account -->
            <a
              routerLink="/app/profile"
              routerLinkActive="!bg-sky-200 !text-black dark:!bg-gray-700 dark:!text-white"
              (click)="closeMoreMenu()"
              data-cy="page-nav-link-account-mobile"
              class="flex items-center p-2 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-150"
            >
              <span class="material-symbols-outlined mr-2">person</span>
              Account
            </a>
          </div>
        </ng-template>
      </li>
    }
  </ul>
</nav>
